export default __webpack_public_path__ + "static/media/wechat-app.e70c99bb.png";